module.exports = "/static/assets/174a52d0c498c26afd00f8a16ed79549.png";